/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { LocalizedBrandService } from './model/localizedBrandService';

export const apiFrontendServiceLandingLocaleRetrieve = (
  countryUrlPrefix: string,
  language: string,
  serviceLandingSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LocalizedBrandService>({
    url: `/api/v7/frontend/service-landing/${countryUrlPrefix}/${language}/${serviceLandingSlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendServiceLandingLocaleRetrieveQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  serviceLandingSlug?: string
) => {
  return [
    `/api/v7/frontend/service-landing/${countryUrlPrefix}/${language}/${serviceLandingSlug}/`,
  ] as const;
};

export const getApiFrontendServiceLandingLocaleRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendServiceLandingLocaleRetrieveQueryKey(
      countryUrlPrefix,
      language,
      serviceLandingSlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>>
  > = ({ signal }) =>
    apiFrontendServiceLandingLocaleRetrieve(countryUrlPrefix, language, serviceLandingSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && language && serviceLandingSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendServiceLandingLocaleRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>>
>;
export type ApiFrontendServiceLandingLocaleRetrieveQueryError = ErrorType<unknown>;

export function useApiFrontendServiceLandingLocaleRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendServiceLandingLocaleRetrieveQueryOptions(
    countryUrlPrefix,
    language,
    serviceLandingSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
